import { render, staticRenderFns } from "./CubeItem.vue?vue&type=template&id=12be9f58&"
import script from "./CubeItem.vue?vue&type=script&lang=js&"
export * from "./CubeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports